import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function TMReport() {
  // ==========================
  // State
  // ==========================
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [services, setServices] = useState([]);

  const [loading, setLoading] = useState(false);

  const [stats, setStats] = useState({
    totalUser: 0,
    totalServices: 0,
    totalCounter: 0,

    todayTotal: 0,
    todayWaiting: 0,
    todayCompleted: 0,
    todaySkipped: 0,

    totalToken: 0,
    waiting: 0,
    completed: 0,
    skipped: 0,
  });

  // ==========================
  // Page Load
  // ==========================
  useEffect(() => {
    loadDashboard();
  }, []);

  // ==========================
  // Dashboard API
  // ==========================
  const loadDashboard = async () => {
    try {
      setLoading(true);

      const [
        totalUser,
        totalServices,
        totalCounter,
        totalToken,
        waiting,
        completed,
        skipped,
        todayTotal,
        todayWaiting,
        todayCompleted,
        todaySkipped,
      ] = await Promise.all([
        api.get("/Dashboard/TotalUser"),
        api.get("/Dashboard/TotalServices"),
        api.get("/Dashboard/TotalCounter"),

        api.get("/Dashboard/totals"),
        api.get("/Dashboard/waitingg"),
        api.get("/Dashboard/completedd"),
        api.get("/Dashboard/skippedd"),

        api.get("/Dashboard/TodayTotal"),
        api.get("/Dashboard/TodayWaiting"),
        api.get("/Dashboard/TodayCompleted"),
        api.get("/Dashboard/TodaySkipped"),
      ]);

      setStats({
        totalUser: totalUser.data,
        totalServices: totalServices.data,
        totalCounter: totalCounter.data,

        totalToken: totalToken.data,
        waiting: waiting.data,
        completed: completed.data,
        skipped: skipped.data,

        todayTotal: todayTotal.data,
        todayWaiting: todayWaiting.data,
        todayCompleted: todayCompleted.data,
        todaySkipped: todaySkipped.data,
      });
    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Dashboard",
        text: "Unable to load dashboard data.",
      });
    } finally {
      setLoading(false);
    }
  };

  // ==========================
  // Search Report
  // ==========================
  const loadServices = async () => {
    if (!fromDate || !toDate) {
      Swal.fire({
        icon: "warning",
        title: "Select Date",
        text: "Please select From Date and To Date.",
      });

      return;
    }

    try {
      setLoading(true);

      const response = await api.get("/Report/DWReports", {
        params: {
          fromDate,
          toDate,
        },
      });

      setServices(response.data);
    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Report",
        text: "Unable to load report.",
      });
    } finally {
      setLoading(false);
    }
  };

  // ==========================
  // Refresh Dashboard
  // ==========================
  const refreshDashboard = () => {
    loadDashboard();
  };

  // ==========================
  // Print Report
  // ==========================
  const printReport = () => {
    window.print();
  };

  // ==========================
  // Export Excel
  // (Implementation in Part 3)
  // ==========================
  //const exportExcel = () => {};
  const exportExcel = () => {
    if (services.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Data",
        text: "No records available to export.",
      });
      return;
    }

    const excelData = services.map((item, index) => ({
      "Sr No": index + 1,
      "Token No": item.tokenNo,
      Counter: item.counterName,
      Service: item.serviceName,
      "Customer Name": item.customerName,
      "Mobile No": item.mobileNo,
      "Created Date": new Date(item.createdDate).toLocaleDateString("en-GB"),
      "Issue Time": item.issueTime
        ? new Date(item.issueTime).toLocaleTimeString()
        : "",
      Status: item.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Token Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(file, "Token_Report.xlsx");
  };
  return (
    <>
      {/* Part 2 Starts Here */}
      <>
        <div className="container-fluid">
          {/* ================= Dashboard ================= */}

          <div className="row mb-4">
            <div className="col-lg-3 col-md-6 mb-3 col-6">
              <div className="card shadow border-0 bg-primary text-white">
                <div className="card-body text-center">
                  <h6>Today's Total Token</h6>
                  <h2>{stats.todayTotal}</h2>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-3 col-6">
              <div className="card shadow border-0 bg-warning text-dark">
                <div className="card-body text-center">
                  <h6>Today's Waiting</h6>
                  <h2>{stats.todayWaiting}</h2>
                </div>
              </div>
            </div>
    <div className="col-lg-3 col-md-6 mb-3 col-6">
              <div className="card shadow border-0 bg-info text-white">
                <div className="card-body text-center">
                  <h6>Today's Skipped</h6>
                  <h2>{stats.todaySkipped}</h2>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-3 col-6">
              <div className="card shadow border-0 bg-olive text-white">
                <div className="card-body text-center">
                  <h6>Today's Completed</h6>
                  <h2>{stats.todayCompleted}</h2>
                </div>
              </div>
            </div>

        
          </div>

          {/* ================= Overall Dashboard ================= */}

          <div className="row mb-4">
            <div className="col-lg-2 col-md-4 mb-3 col-4">
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <h6>Total Users</h6>
                  <h3>{stats.totalUser}</h3>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-4 mb-3 col-4">
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <h6>Total Counters</h6>
                  <h3>{stats.totalCounter}</h3>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 mb-3 col-4">
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <h6>Total Token</h6>
                  <h3>{stats.totalToken}</h3>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 mb-3 col-4">
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <h6>Waiting</h6>
                  <h3>{stats.waiting}</h3>
                </div>
              </div>
            </div>

                 <div className="col-lg-2 col-md-6 mb-3 col-4">
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <h6>Skipped</h6>
                  <h3>{stats.skipped}</h3>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 mb-3 col-4">
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <h6>Completed</h6>
                  <h3>{stats.completed}</h3>
                </div>
              </div>
            </div>

       
          </div>

          {/* ================= Master Information ================= */}

          {/* <div className="row mb-4">

      

      <div className="col-lg-2 col-md-4 mb-3">
        <div className="card border-0 shadow-sm">
          <div className="card-body text-center">
            <h6>Total Services</h6>
            <h3>{stats.totalServices}</h3>
          </div>
        </div>
      </div>

    </div> */}

          {/* ================= Search Panel ================= */}

          <div className="card shadow-sm mb-4">
            <div className="card-header bg-dark text-white">
              <strong>Search Report</strong>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <label className="form-label">From Date</label>

                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">To Date</label>

                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 d-flex align-items-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={loadServices}
                  >
                    <i className="bi bi-search"></i> Search
                  </button>

                   <button
              className="btn btn-success me-2"
              onClick={exportExcel}
            >
              Export Excel
            </button>

            <button
              className="btn btn-danger me-2"
              onClick={printReport}
            >
              Print
            </button> 

                  <button
                    className="btn btn-secondary"
                    onClick={refreshDashboard}
                  >
                    <i className="bi bi-arrow-clockwise"></i> Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>

          {loading && (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {/* ======= Part 3 Table Starts Here ======= */}
          {!loading && (
            <div className="card shadow-sm">
              <div className="card-header bg-primary text-white">
                <strong>Token Report</strong>
              </div>

              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover mb-0">
                    <thead className="table-dark">
                      <tr>
                        <th>Sr.</th>
                        <th>Token No</th>
                        <th>Counter</th>
                        <th>Service</th>
                        <th>Customer</th>
                        <th>Mobile</th>
                        <th>Created Date</th>
                        <th>Issue Time</th>
                        <th>Status</th>
                      </tr>
                    </thead>

                    <tbody>
                      {services.length > 0 ? (
                        services.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>

                            <td>{item.tokenNo}</td>

                            <td>{item.counterName}</td>

                            <td>{item.serviceName}</td>

                            <td>{item.customerName}</td>

                            <td>{item.mobileNo}</td>

                            <td>
                              {item.createdDate
                                ? new Date(item.createdDate).toLocaleDateString(
                                    "en-GB",
                                  )
                                : "-"}
                            </td>

                            <td>
                              {item.issueTime
                                ? new Date(item.issueTime).toLocaleTimeString()
                                : "-"}
                            </td>

                            <td>
                              {item.status === "Waiting" && (
                                <span className="badge bg-warning text-dark">
                                  Waiting
                                </span>
                              )}

                              {item.status === "Completed" && (
                                <span className="badge bg-success">
                                  Completed
                                </span>
                              )}

                              {item.status === "Skipped" && (
                                <span className="badge bg-danger">Skipped</span>
                              )}

                              {item.status !== "Waiting" &&
                                item.status !== "Completed" &&
                                item.status !== "Skipped" && (
                                  <span className="badge bg-secondary">
                                    {item.status}
                                  </span>
                                )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No Record Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    </>
  );
}

export default TMReport;
